import { render, staticRenderFns } from "./vip-targeted-list.vue?vue&type=template&id=42836a5c&scoped=true&"
import script from "./vip-targeted-list.vue?vue&type=script&lang=js&"
export * from "./vip-targeted-list.vue?vue&type=script&lang=js&"
import style0 from "./vip-targeted-list.vue?vue&type=style&index=0&id=42836a5c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42836a5c",
  null
  
)

export default component.exports